import {useContext,useEffect,useState} from 'react';
import axios from 'axios';
import baseUrl from '../../../BaseURL';
import {ContextData} from '../../../context/Context';

const EMPTY_MEMBERS=[];
export default function useReviewMembers(token,stage) {
 const {accesstoken,Refresh}=useContext(ContextData);
 const [result,setResult]=useState({key:'',members:[],hasMore:false});
 const [loading,setLoading]=useState(false),[error,setError]=useState('');
 const [request,setRequest]=useState({key:'',offset:0,version:0});
 const key=JSON.stringify([token,stage,Refresh,accesstoken]);
 const offset=request.key===key?request.offset:0;
 useEffect(()=>{
  if(!token)return;
  const controller=new AbortController();setLoading(true);setError('');
  axios.get(`${baseUrl}/auth/get_data_member_user/${encodeURIComponent(token)}`,{
   signal:controller.signal,withCredentials:true,timeout:15000,
   headers:{authorization:`Bearer ${accesstoken}`},params:{stage,limit:40,offset}
  }).then(({data})=>{
   if(controller.signal.aborted)return;
   setResult(previous=>({key,hasMore:data.hasMore,members:offset&&previous.key===key?
    Array.from(new Map([...previous.members,...data.members].map(member=>[member.token,member])).values()):data.members}));
  }).catch(err=>{if(!controller.signal.aborted)setError('Members could not be loaded. Please retry.');})
   .finally(()=>{if(!controller.signal.aborted)setLoading(false);});
  return ()=>controller.abort();
 },[token,stage,accesstoken,key,offset,request.version]);
 return {members:result.key===key?result.members:EMPTY_MEMBERS,hasMore:result.key===key&&result.hasMore,loading,error,
  fetchMore:()=>setRequest({key,offset:result.members.length,version:request.version+1}),
  reload:()=>setRequest({key,offset,version:request.version+1})};
}
